<template>
  <b-card
    no-body
    class=""
  >
    <b-card-header>
      <b-card-title>Akumulasi Penjualan</b-card-title>
    </b-card-header>
    <b-card-body>
      <b-row>
        <b-col
          v-for="(item, index) in statisticsItem"
          :key="index"
          md="6"
          sm="6"
          class="mb-2"
          :class="item.customClass"
        >
          <b-avatar
            size="48"
            :variant="item.color"
            class="mb-1"
          >
            <feather-icon
              size="24"
              :icon="item.icon"
            />
          </b-avatar>
          <b-card-text class="font-small-3 mb-0">
            {{ item.subtitle }}
          </b-card-text>
          <div class="d-flex align-items-center mb-50 mt-25">
            <h4 class="font-weight-bolder mb-0 mr-50">
              {{ item.title }}
            </h4>
            <div v-if="item.tooltip">
              <feather-icon
                :id="`sales-tooltip-${index}`"
                icon="InfoIcon"
                size="16"
                class="cursor-pointer text-muted"
              />
              <b-tooltip
                :target="`sales-tooltip-${index}`"
                triggers="hover"
              >
                <div class="text-left text-nowrap">
                  <div>Midtrans: {{ item.tooltip.midtrans }}</div>
                  <div>Xendit: {{ item.tooltip.xendit }}</div>
                </div>
              </b-tooltip>
            </div>
          </div>
          <b-badge :variant="item.color">
            AVG: {{ toCurrency(item.avg.toFixed(0)) }}
          </b-badge>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardTitle, BCardText, BCardBody, BRow, BCol, BAvatar, BBadge, BTooltip,
} from 'bootstrap-vue'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardText,
    BCardBody,
    BAvatar,
    BBadge,
    BTooltip,
  },
  props: {
    data: {
      type: Array,
      default: () => ([]),
    },
  },
  computed: {
    totalSales() {
      // eslint-disable-next-line radix
      // return this.data.reduce((total, el) => total + parseInt(el.external_sales) + parseInt(el.partnered_brand_sales) + parseInt(el.miniapoly_official_store_sales), 0)
      return this.totalEksternal + this.totalInternalRegistry + this.totalInternalNonRegistry
    },
    totalEksternal() {
      // eslint-disable-next-line radix
      return this.data.reduce((total, el) => total + parseInt(el.external_sales), 0)
    },
    totalInternal() {
      // eslint-disable-next-line radix
      return this.data.reduce((total, el) => total + parseInt(el.internal_sales), 0)
    },
    totalInternalMidtrans() {
      return this.data.reduce((total, el) => total + parseInt(el.internal_sales_midtrans || 0, 10), 0)
    },
    totalInternalXendit() {
      return this.data.reduce((total, el) => total + parseInt(el.internal_sales_xendit || 0, 10), 0)
    },
    totalInternalRegistry() {
      // eslint-disable-next-line radix
      return this.data.reduce((total, el) => total + parseInt(el.internal_registry_sales), 0)
    },
    totalInternalNonRegistry() {
      // eslint-disable-next-line radix
      return this.data.reduce((total, el) => total + parseInt(el.internal_non_registry_sales), 0)
    },
    statisticsItem() {
      return [
        {
          icon: 'ArchiveIcon',
          color: 'light-primary',
          title: this.toCurrency(this.totalSales),
          avg: this.getAvgAllProduct(),
          subtitle: 'Semua Transaksi',
          customClass: 'mb-2',
        },
        {
          icon: 'DollarSignIcon',
          color: 'light-success',
          title: this.toCurrency(this.totalInternal),
          avg: this.getAvgInternal(),
          subtitle: 'Transaksi Internal',
          tooltip: {
            midtrans: this.toCurrency(this.totalInternalMidtrans),
            xendit: this.toCurrency(this.totalInternalXendit),
          },
          customClass: 'mb-2',
        },
        {
          icon: 'GiftIcon',
          color: 'light-warning',
          title: this.toCurrency(this.totalEksternal),
          avg: this.getAvgEksternal(),
          subtitle: 'Transaksi Eksternal Registry',
          customClass: 'mb-2',
        },
        {
          icon: 'GiftIcon',
          color: 'light-info',
          title: this.toCurrency(this.totalInternalRegistry),
          avg: this.getAvgInternalRegistry(),
          subtitle: 'Transaksi Internal Registry',
          customClass: 'mb-2',
        },
        // {
        //   icon: 'BoxIcon',
        //   color: 'light-info',
        //   title: this.toCurrency(this.totalInternalNonRegistry),
        //   avg: this.getAvgInternalNonRegistry(),
        //   subtitle: 'Transaksi e-Commerce',
        //   customClass: 'mb-2',
        // },
      ]
    },
  },
  methods: {
    formula(avg, count) {
      const sumAvgXCount = this.data.reduce((total, el) => total + (el[avg] * el[count]), 0)
      const sumAllProductCount = this.data.reduce((total, el) => total + el[count], 0)

      return sumAllProductCount ? sumAvgXCount / sumAllProductCount : 0
    },
    getAvgAllProduct() {
      // note rumus avg all product
      // [SUM (all_transaction_avg_sales * all_internal_transaction_count)] / [SUM all_internal_transaction_count]
      return this.formula('all_transaction_avg_sales', 'all_transaction_count')
    },
    getAvgEksternal() {
      // note rumus avg eksternal product
      // [SUM (external_transaction_avg_sales * external_transaction_count)] / [SUM external_transaction_count]
      return this.formula('external_transaction_avg_sales', 'external_transaction_count')
    },
    getAvgInternal() {
      // note rumus avg internal product
      // [SUM (internal_product_avg_price * internal_transaction_count)] / [SUM internal_transaction_count]
      return this.formula('internal_transaction_avg_sales', 'all_internal_transaction_count')
    },
    getAvgInternalNonRegistry() {
      // note rumus avg internal non registry product
      // [SUM (internal_non_registry_transaction_avg_sales * internal_non_registry_transaction_count)] / [SUM internal_non_registry_transaction_count]
      return this.formula('internal_non_registry_transaction_avg_sales', 'internal_non_registry_transaction_count')
    },
    getAvgInternalRegistry() {
      // note rumus avg internal registry product
      // [SUM (internal_registry_transaction_avg_sales * internal_registry_transaction_count)] / [SUM internal_registry_transaction_count]
      return this.formula('internal_registry_transaction_avg_sales', 'internal_registry_transaction_count')
    },
  },
}
</script>
